export default __webpack_public_path__ + "static/media/elite_bull.abaffbe0.png";